import { render, staticRenderFns } from "./PFSummeryFront.vue?vue&type=template&id=312635b5"
import script from "./PFSummeryFront.vue?vue&type=script&lang=js"
export * from "./PFSummeryFront.vue?vue&type=script&lang=js"
import style0 from "./PFSummeryFront.vue?vue&type=style&index=0&id=312635b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports